export default "__VITE_ASSET__oFBl8_pe__"